export default {
  template: '#designer-item-template',
  async created() {
    this.setId();

    if (!this.isCreateSimilar && !this.isDraft) {
      this.setX();

      if (this.item.type === "TEXT") {
        this.innerHtml = this.getSVGText();

        await this.$nextTickPromise();
        this.reCalculateBoundingBox();

        await this.$nextTickPromise();
        this.centerBlock();
      } else {
        if (this.isNonMovableDesignProduct === false) {
          this.centerBlock()
        }
      }
    } else {
      if (this.item.type === "TEXT") {
        this.innerHtml = this.getSVGText();

        await this.$nextTickPromise();
        this.reCalculateBoundingBox(true);
      }
    }

    if (this.item.type == "ARTWORK") {
      this.artworkHtml = this.item.value;
    }

    this.$on('item-unselect', () => {
      this.disableControls();
    });

    this.$on('recalculate-bounding-box', async () => {
      await this.$nextTickPromise();

      this.reCalculateBoundingBox();
    });

    this.$on('force-select', () => {
      if (this.id == this.$root.selectedItem.id) {
        this.onSelected();
      }
    });
  },
  watch: {
    'item.value': function(val, oldVal) {
      if (this.item.type == "TEXT") {
        this.innerHtml = this.getSVGText();
        this.reCalculateBoundingBox();
      }
    },
    'item.text_block': function(val, oldVal) {
      this.innerHtml = this.getSVGText();
      this.reCalculateBoundingBox();
    },
    'item.element': {
      deep: true,
      handler: function() {
        if (this.item.type == "TEXT")
          this.reCalculateBoundingBox();
      }
    },
    async 'item.element.font_family'(val, oldVal) {
      this.$set('item.element.font_url', this.$root.getFontURLByName(val));

      await this.$nextTickPromise();

      this.reCalculateBoundingBox();
    },
    'item.element.stroke_width': function(val) {
      var strokeColor;
      if (parseInt(val, 10) > 0) {
        strokeColor = this.item.element.stroke;
        this.$root.storeColors(strokeColor, this.$root.currentSide);
      } else {
        strokeColor = this.item.element.stroke;
        this.$root.removeColors(strokeColor, this.$root.currentSide);
      }
      this.reCalculateBoundingBox();
    }
  },
  ready() {
    this.selectItem();
    this.setupKeyBoardEvents();
  },
  props: ['item', 'side', 'index'],
  events: {
    'on-auto-align': function() {
      this.reCalculateBoundingBox(true);
      this.alignH();
    }
  },
  data: () => ({
    viewBox: '0 0 0 0',
    id: '',
    innerHtml: '',
    artworkHtml: ''
  }),
  methods: {
    $_transformHelper(element, position, width, height) {
      let container = element.parent().parent(),
        containerWidth = parseFloat(container.css('width')),
        containerHeight = parseFloat(container.css('height')),
        left = parseFloat(position.left),
        top = parseFloat(position.top),
        boundingRect = element[0].getBoundingClientRect(),
        hasTransform = element[0].style.transform;

      if (left < 0 || top < 0 || (left + width) > containerWidth || (top + height) > containerHeight) {
        element.css('border', '1px solid #FF0000');
      } else {
        element.css('border', '1px dashed #666666');
      }

      this.$set('item.span.left', left);
      this.$set('item.span.top', top);
      this.$set('item.span.width', hasTransform ? element.outerWidth() : boundingRect.width);
      this.$set('item.span.height', hasTransform ? element.outerHeight() : boundingRect.height);
    },
    $_stopTransformHelper() {
      let activeElement = $('.drag-item-selected'),
        boundingRect = activeElement[0].getBoundingClientRect(),
        hasTransform = activeElement[0].style.transform;

      this.$root.setRotationCoordinates(this.item);

      this.$set('item.span.width', hasTransform ? activeElement.outerWidth() : boundingRect.width);
      this.$set('item.span.height', hasTransform ? activeElement.outerHeight() : boundingRect.height);
    },
    getItemType: function() {
      return this.item.type;
    },
    centerBlock: function() {
      var obj = this.item;
      var height = parseFloat(obj.span.height),
        width = parseFloat(obj.span.width),
        currentSide = this.$root.currentSide,
        ph = parseFloat(this.$root.selectedProduct.dimensions[currentSide].offsets.height),
        pw = parseFloat(this.$root.selectedProduct.dimensions[currentSide].offsets.width);

      obj.span.top = (ph - height) / 2;
      obj.span.left = (pw - width) / 2;
    },
    selectItem: function(e) {
      if (e) e.stopPropagation();

      this.$root.unSelectAllControls();
      this.$root.$set('selectedItem', this.item);
      this.$dispatch('item-selected');
      this.onSelected();
    },
    onSelected: function() {
      if ($(this.$el).resizable("instance")) {
        if ($(this.$el).resizable('option', 'disabled')) {
          this.enableControls();
        }
      } else {
        this.setupResizableAndRotatable(this.$el);
        this.setupDraggable(this.$el);
        this.setupIcons(this.$el);
      }
    },
    setupDraggable: function(el) {
      $(el).draggable({
        drag: (event, ui) => this.$_transformHelper(ui.helper, ui.position, ui.helper.width(), ui.helper.height()),
        stop: this.$_stopTransformHelper,
      });
    },
    setupResizableAndRotatable: function(el) {
      $(el).resizable({
        minHeight: 15,
        minWidth: 15,
        aspectRatio: (parseFloat(el.style.width) / parseFloat(el.style.height)) || true,
        handles: 'se',
        grid: [1, 1],
        resize: (event, ui) => this.$_transformHelper(ui.element, ui.position, parseFloat(ui.size.width), parseFloat(ui.size.height)),
        stop: this.$_stopTransformHelper,
      }).rotatable({
        angle: this.item.rotate,
        rotate: (event, ui) => {
          this.$set('item.rotate', ui.angle.current);

          $(el).find('div').each(function(idx, el) {
            $(el).css({ 'transform': 'rotate(' + (-(ui.angle.current)) + 'rad)' });
          });
        },
        wheelRotate: false,
        stop: this.$_stopTransformHelper,
      })
    },
    setupIcons: function(el) {
      $(el).find('.ui-rotatable-handle').addClass('glyphicons restart')
    },
    setViewBox: function(width, height) {
      this.$set('viewBox', '0 0 ' + width + ' ' + height);
    },
    setId: function() {
      this.$set('id', this.item.id);
    },
    setX: function() {
      this.$set('item.element.x', parseFloat(this.item.span.width) / 2);
    },
    removeItem: function() {
      this.$dispatch('item-removed', this.item.id);
    },
    enableControls: function() {
      $(this.$el).resizable('enable');
      $(this.$el).draggable('enable');
      $(this.$el).find('.ui-resizable-handle').show();
    },
    disableControls: function() {
      if ($(this.$el).resizable("instance")) {
        $(this.$el).find('.ui-resizable-handle').hide();
        $(this.$el).resizable('disable');
        $(this.$el).draggable('disable');
      }
    },
    disableMove() {
      $(this.$el).draggable('disable');

      $(document).on('mouseup', this.enableMove);
    },
    enableMove() {
      $(this.$el).draggable('enable');

      $(document).off('mouseup', this.enableMove);
    },
    getSVGText: function() {
      var texts = this.item.value.split('\n'),
        svgNS = "http://www.w3.org/2000/svg",
        textContent = '';
      for (var i = 0; i < texts.length; i++) {
        var tspan = document.createElementNS(svgNS, 'tspan');
        tspan.setAttributeNS(null, 'dy', this.item.element.font_size.replace('px', ''));
        tspan.setAttributeNS(null, 'x', 0);
        var content = document.createTextNode(texts[i]);
        tspan.appendChild(content);
        textContent += tspan.outerHTML;
      }

      return textContent;
    },
    reCalculateBoundingBox: function(skipResize) {
      var item = this.item,
        tempSVG = $('#svgTemp'),
        textBlock = this.item.text_block,
        halfLetterSpacing = this.letterSpacing / 2;

      $(tempSVG).html(
        `<svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                preserveAspectRatio="none"
          >
              <g>
                  <text
                      fill="${item.element.fill}"
                      stroke="${item.element.stroke}"
                      stroke-width="${this.letterSpacing}"
                      stroke-linecap="${item.element.stroke_linecap}"
                      stroke-linejoin="${item.element.stroke_linejoin}"
                      text-anchor="${item.element.text_anchor}"
                      font-size="${item.element.font_size}"
                      font-family="${item.element.font_family}" x="0" y="0"
                      paint-order="stroke"
                      letter-spacing="${this.letterSpacing}px"
                  >
                      ${this.innerHtml}
                  </text>
              </g>
          </svg>`
      );

      if (textBlock) {
        $(tempSVG).css({
          fontStyle: textBlock.font_style,
          fontWeight: textBlock.font_weight,
          textDecoration: textBlock.text_decoration
        });
      }

      var svg = this.$root.processSVGToRemoveWhitespace($(tempSVG).find('svg')[0]),
        currentSide = this.$root.currentSide,
        currentProductWidth = parseFloat(this.$root.selectedProduct.dimensions[currentSide].offsets.width),
        desiredWidth = currentProductWidth,
        desiredHeight = (svg.height / svg.width) * desiredWidth;

      if (!skipResize) {
        this.$set('item.span.width', svg.width);
        this.$set('item.span.height', svg.height);
      }

      let viewBox = svg.viewBox.split(',');

      viewBox[0] = parseFloat(viewBox[0]) - halfLetterSpacing;
      viewBox[1] = parseFloat(viewBox[1]) - halfLetterSpacing;
      viewBox[2] = parseFloat(viewBox[2]) + this.letterSpacing;
      viewBox[3] = parseFloat(viewBox[3]) + this.letterSpacing;

      this.$set('item.span.autoScaleWidth', desiredWidth);
      this.$set('item.span.autoScaleHeight', desiredHeight);
      this.$set('viewBox', viewBox.join(','));
      this.$root.setRotationCoordinates(this.item);

      $('body').append(svgTemp)
    },
    getTextBlockStyle: function() {
      var text_block = this.item.text_block;
      return {
        fontStyle: text_block.font_style,
        fontWeight: text_block.font_weight,
        textDecoration: text_block.text_decoration,
      };
    },
    alignV: function() {
      var selectedProduct = this.$root.selectedProduct,
        height = this.item.span.height,
        currentSide = this.$root.currentSide,
        ph = parseFloat(selectedProduct.dimensions[currentSide].offsets.height) - 2,
        h = (ph - height) / 2;

      this.$set('item.span.top', h);
    },
    alignH: function() {
      var selectedProduct = this.$root.selectedProduct,
        width = this.item.span.width,
        currentSide = this.$root.currentSide,
        pw = parseFloat(selectedProduct.dimensions[currentSide].offsets.width) - 2,
        w = (pw - width) / 2;

      this.$set('item.span.left', w);
    },
    computeGuidesForElement: function(elem, pos, w, h) {
      if (elem != null) {
        var $t = $(elem);
        pos = $t.offset();
        w = $t.outerWidth() - 1;
        h = $t.outerHeight() - 1;
      }

      return [{
          type: "h",
          left: pos.left,
          top: pos.top
        }, {
          type: "h",
          left: pos.left,
          top: pos.top + h
        }, {
          type: "v",
          left: pos.left,
          top: pos.top
        }, {
          type: "v",
          left: pos.left + w,
          top: pos.top
        },
        // you can add _any_ other guides here as well (e.g. a guide 10 pixels to the left of an element)
        {
          type: "h",
          left: pos.left,
          top: pos.top + h / 2
        }, {
          type: "v",
          left: pos.left + w / 2,
          top: pos.top
        }
      ];
    },
    scaleItem: function(item) {
      if (item.type == "IMAGE") {
        let offsets = this.$root.selectedProduct.dimensions[this.$root.currentSide].offsets,
          maxHeight = parseFloat(offsets.height),
          maxWidth = parseFloat(offsets.width),
          autoWidth = item.imageData.width / item.imageData.height * maxHeight,
          autoHeight = item.imageData.height / item.imageData.width * maxWidth;

        if (autoHeight <= maxHeight) {
          this.$set('item.span.height', autoHeight);
          this.$set('item.span.width', maxWidth);
        } else {
          this.$set('item.span.height', maxHeight);
          this.$set('item.span.width', autoWidth);
        }
      } else if (item.type == "TEXT") {
        this.$set('item.span.height', item.span.autoScaleHeight);
        this.$set('item.span.width', item.span.autoScaleWidth);
      }

      setTimeout(() => {
        this.alignH();
        this.alignV();
      }, 1);
    },
    setupKeyBoardEvents: function() {
      $(document).bind('keydown', '#' + this.item.id, e => {
        var wizardIndex = $('#form_wizard_1').bootstrapWizard('currentIndex');

        if (wizardIndex == 0) {
          var preventElements = ['textarea', 'input', 'select-one', 'text'];

          if (preventElements.indexOf(e.target.type) < 0) {
            if (this.isSelected) {
              var left = this.item.span.left,
                top = this.item.span.top;

              if (e.which === 37) { //Left Arrow
                this.$set('item.span.left', parseFloat(left) - 1);
              } else if (e.which === 38) { //Up Arrow
                this.$set('item.span.top', parseFloat(top) - 1);
              } else if (e.which === 39) { //Right Arrow
                this.$set('item.span.left', parseFloat(left) + 1);
              } else if (e.which === 40) { //Down Arrow
                this.$set('item.span.top', parseFloat(top) + 1);
              }

              this.$root.setRotationCoordinates(this.item);

              e.preventDefault();
            }
          }
        } else {
          return true;
        }
      });
    }
  },
  computed: {
    isCanvas: function() {
      if (this.$root.selectedProduct)
        return this.$root.selectedProduct.product.render_type === 'CANVAS';

      return false;
    },
    isMats: function() {
      if (this.$root.selectedProduct)
        return this.$root.selectedProduct.product.product_type === 'MATS';

      return false;
    },
    isTowels: function() {
      if (this.$root.selectedProduct)
        return this.$root.selectedProduct.product.product_type === 'TOWELS';

      return false;
    },
    isFlag: function() {
      if (this.$root.selectedProduct) {
        return this.$root.selectedProduct.product.product_type === 'FLAG'
      }
    },
    isPoster: function() {
      if (this.$root.selectedProduct) {
        return this.$root.selectedProduct.product.product_type === 'POSTER'
      }
    },
    isMask: function() {
      if (this.$root.selectedProduct) {
        return this.$root.selectedProduct.product.product_type === 'MASK'
      }
    },
    isNonMovableDesignProduct: function() {
      return (this.isCanvas || this.isMats || this.isTowels || this.isFlag || this.isPoster|| this.isMask);
    },
    isCreateSimilar() {
      return this.$root.campaignData.createSimilar === true;
    },
    isDraft() {
      return this.$root.campaignData.isDraft === true;
    },
    spanStyle() {
      return {
        'z-index': this.item.span.index,
        'position': 'absolute',
        border: this.isSelected ? '1px dashed rgb(68, 68, 68)' : 'none',
        top: this.item.span.top + 'px',
        width: this.item.span.width + 'px',
        height: this.item.span.height + 'px',
        left: this.item.span.left + 'px'
      }
    },
    isSelected() {
      return _.get(this.$root, 'selectedItem.id') == this.id;
    },
    letterSpacing() {
      return parseInt(this.item.element.stroke_width || 0) || 0;
    },
  }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/designerItem.js